import type { SVGProps } from 'react';

const SvgGlobe = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M1.655 7.375h1.97c.08-1.772.498-3.388 1.155-4.62q.105-.195.22-.381a6.38 6.38 0 0 0-3.345 5.001m6.281-7a7.625 7.625 0 0 0 .038 15.25H8A7.625 7.625 0 1 0 7.936.375m-.561 1.38c-.514.224-1.038.739-1.492 1.59-.549 1.027-.927 2.435-1.006 4.03h2.498zm0 6.87H4.877c.08 1.595.457 3.003 1.006 4.03.454.851.978 1.366 1.492 1.59zM5 13.626a7 7 0 0 1-.22-.382c-.657-1.23-1.074-2.847-1.154-4.619h-1.97A6.38 6.38 0 0 0 5 13.626m5.923.04a6.38 6.38 0 0 0 3.422-5.041h-2.023c-.08 1.772-.497 3.388-1.154 4.62a7 7 0 0 1-.245.422m.148-5.041H8.625v5.596c.498-.235 1.002-.744 1.44-1.566.549-1.027.927-2.435 1.006-4.03m0-1.25H8.625V1.779c.498.235 1.002.744 1.44 1.566.549 1.027.927 2.435 1.006 4.03m1.251 0c-.08-1.772-.497-3.388-1.154-4.62a7 7 0 0 0-.245-.422 6.38 6.38 0 0 1 3.422 5.042z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgGlobe;
